<!--基本html代码区域-->
<template>


  <el-dialog top="10px" title="" :visible.sync="dialogVisible" :width="dialogWidth" :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false">
  <el-tabs value="first" style="padding: 10px">
    <el-tab-pane label="快捷登陆" name="first" style="margin-top: 10px">
      <el-form ref="formCode" :rules="rulesCode" :model="formCode" style="">
        <el-row type="flex" justify="center">
          <el-col>
            <el-form-item prop="phone_num">
              <el-input v-model="formCode.phone_num">
                <template slot="prepend">手&nbsp;&nbsp;&nbsp;机</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col>
            <el-form-item prop="code">
              <el-input v-model="formCode.code">
                <template slot="prepend">验证码</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col style="width: 30%">
            <el-button type="default" @click="sendVerifyCode" style="margin-left: 10px" :disabled="buttonDisable">
              {{buttonText}}
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col>
            <el-form-item>
              <el-button  class="btn" @click="loginCode" style="width: 100%">登录</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>


    </el-tab-pane>
    <!-- <el-tab-pane label="密码登陆" name="second">

      <el-form ref="form" :rules="rules" :model="form" style="">
        <el-row type="flex" justify="center">
          <el-col>
            <el-form-item prop="phone_num">
              <el-input id="phone_num" v-model="form.phone_num">
                <template slot="prepend">手机</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col>
            <el-form-item prop="password">
              <el-input id="password" type="password" v-model="form.password">
                <template slot="prepend">密码</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col>
            <el-form-item>
              <el-button id="login_btn"  class="btn" @click="login" style="width: 100%">登录</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </el-tab-pane> -->
  </el-tabs>
  </el-dialog>

</template>


<!--数据存贮交互，事件控制地区-->
<script>
  import md5 from 'js-md5';
  import WKSDK from "wukongimjssdk"

  let count;
  export default {
    name: 'Login',
    data () {
      return {
        dialogWidth: '30%',
        dialogVisible: false,
        timer: null,
        buttonText: '发送',
        buttonDisable: false,
        form: {
          phone_num: '',
          password: ''
        },
        formCode: {
          phone_num: '',
          code: ''
        },
        rules: {
          phone_num: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {min: 11, max: 11, message: '长度11位', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'change'}
          ]
        },
        rulesCode: {
          phone_num: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {min: 11, max: 11, message: '长度11位', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入验证码', trigger: 'change'},
            {min: 6, max: 6, message: '长度6位', trigger: 'blur'}
          ]
        }

      }
    },

    mounted() {
      // 初始化时设置对话框宽度
      this.updateDialogWidth();
      // 监听窗口大小变化
      window.addEventListener('resize', this.updateDialogWidth);
    },
    beforeDestroy() {
      // 移除事件监听器
      window.removeEventListener('resize', this.updateDialogWidth);
    },
    methods: {
      init:function () {
        count = 60;
        clearInterval(this.timer);
        this.timer = null;
        this.dialogVisible = true;
      },
      updateDialogWidth() {
        if (window.innerWidth < 600) {
          this.dialogWidth = '90%'; // 小屏幕
        } else if (window.innerWidth < 1024) {
          this.dialogWidth = '50%'; // 中等屏幕
        } else {
          this.dialogWidth = '30%'; // 大屏幕
        }
      },
      getChain: function () {
        let that = this;
        this.$get(
          {
            context: that,
            path: '/chain/detail/',
            params: {},
            success: function (data) {
              let chainStatus = data.chain.chainStatus;
              if (chainStatus != 3) {
                console.log(fdasfsafdasfdasfadfa)
                that.$router.push({path: '/verify'});
              } else {
                that.$router.push({path: '/app'});
              }
            }
          }
        )
      },

      sendVerifyCode: function () {
        let phoneNum = this.formCode.phone_num;
        if (phoneNum == null || phoneNum == '') {
          this.$alert('请填写手机号', '错误', {
            confirmButtonText: '知道了',
            callback: action => {
            }
          });
          return;
        }

        this.sendCode();
        this.buttonDisable = true;
        //countdown
        clearInterval(this.timer);
        this.timer = null;
        this.setTimer()

      },

      login: function () {
        let that = this;
        this.$post(
          {
            context: that,
            path: '/user/login/password/',
            params: {
              phone_num: this.form.phone_num,
              password: md5(this.form.password)
            },
            success: function (data) {
              that.form = {};
              localStorage.setItem("token", data.token);
              localStorage.setItem("userId", data.userId);
              that.dialogVisible = false;
              that.syncData(data.userId,data.token)
              that.$emit('loginSuccess');
              that.initIm()
              clearInterval(that.timer);
              that.timer = null
            }
          }
        )
      },
      loginCode: function () {

        let that = this;
        this.$refs['formCode'].validate((valid) => {
          if (valid) {

            that.$post(
              {
                context: that,
                path: '/user/login/code/',
                params: {
                  phone_num: this.formCode.phone_num,
                  code: this.formCode.code, //this.formCode.code
                },
                success: function (data) {
                  that.formCode = {};
                  localStorage.setItem("token", data.token);
                  localStorage.setItem("userId", data.userId);
                  that.dialogVisible = false;
                  that.syncData(data.userId,data.token)
                  that.$emit('loginSuccess');
                  that.initIm()
                  clearInterval(that.timer);
                  that.timer = null
                }
              }
            )

          } else {
            return false;
          }
        });

      },

      initIm() {
        const token = localStorage.getItem("token")
        if (!token) {
          return
        }

        let t = this;
        this.$get(
          {
            context: t,
            path: '/im/login/',
            params: {},
            success: function (data) {
              console.log(data)
              if (data.uid) {
                WKSDK.shared().config.addr = data.api;
                WKSDK.shared().config.uid = data.uid;
                WKSDK.shared().config.token = data.token;
                WKSDK.shared().connectManager.connect();
                WKSDK.shared().connectManager.addConnectStatusListener(
                  (status, reasonCode) => {
                    console.log(status)
                    if (status === 1) {
                      console.log('连接成功');
                    } else {
                      console.log('连接失败', reasonCode); //  reasonCode: 2表示认证失败（uid或token错误）
                    }
                  },
                );

              }
            }
          }
        )
      },

      syncData(userId, token){
        try {
          if (window.pywebview) {
            window.pywebview.api.save_user_data(userId,token).then(function (response) {
            });
          }
        }catch (e){
          console.log(e)
        }
      },
      sendCode: function () {
        let that = this;
        that.$post(
          {
            context: that,
            path: '/system/verify/code/send/',
            params: {
              phone_num: that.formCode.phone_num,
            },
            success: function (data) {
              console.log(data);
            }
          }
        )
      },

      setTimer() {
        if (this.timer == null) {
          this.timer = setInterval(() => {
            if (count <= 0) {
              count = 60;
              this.buttonText = "发送";
              this.buttonDisable = false;
              clearInterval(this.timer);
              this.timer = null;
              return;
            }
            count--;
            this.buttonText = count + "s";
          }, 1000)
        }
      }
    }
  }
</script>
<style scoped >
  @import '../assets/global.css';
</style>


